<div class="telus-button telus-dropdown" *transloco="let t">
  <span>Bulk action</span>
  <ion-icon name="chevron-down"></ion-icon>
  <div class="dropdown-content">
    <p
      class="dropdown-item"
      *ngFor="let action of actions"
      (click)="onAction(action)"
    >
      {{ action }}
    </p>
  </div>
</div>
